import React from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import Wrapper from "../atoms/Wrapper";
import SelectedVTuberListItem from "../organisms/SelectedVTuberListItem";
import Link from "../atoms/Link";

const StyledImg = styled.img`
  width: 150px;

  @media (min-width: 760px) {
    width: 256px;
    height: 144px;
  }
`;
const Description = styled(Wrapper)`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: calc(100% * 0.5625);
  color: ${(props) => props.theme.colors.black};

  width: 100%;
  padding-left: 0.5rem;

  @media (min-width: 760px) {
    padding-left: 0.1rem;
    padding-right: 0.1rem;
  }
`;

const StyledA = styled(Link)`
  justify-content: flex-start;
  padding: 0;
  position: relative;
  width: 100%;

  ${(props) => (props.fullwidth ? "width: 100%;" : "")}
`;
const Title = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;

  font-size: 1rem;
  line-height: 1.4rem;
  max-height: 2.8rem;

  width: 100%;
  color: ${(props) => props.theme.colors.black};
  margin: 0.4rem 0 0.1rem 0;

  @media (max-width: 760px) {
    margin: 0;
    margin-top: -1px;

    font-size: 0.9rem;
    line-height: 1.26rem;
    max-height: 2.52rem;
  }
`;

const DescriptionMiddle = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 1.5rem;
  margin-bottom: 0.1rem;

  @media (max-width: 760px) {
    height: 1.4rem;
    margin-bottom: 0;
  }
`;

const DescriptionContents = styled.span`
  text-overflow: ellipsis;
  font-size: 0.8125rem;
  height: 1.5rem;
  line-height: 1.5rem;
  color: ${(props) => props.theme.colors.gray};

  @media (max-width: 760px) {
    margin: 0;
    font-size: 0.8rem;
    line-height: 1.4rem;
  }
`;

const Separator = styled.span`
  ::before {
    content: "•";
    margin: 0 0.2rem;
    color: ${(props) => props.theme.colors.gray};
  }
`;

const StyledWrapper = styled(Wrapper)`
  width: calc(100% - 16px);
  margin: 0 8px 8px 8px;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;

  @media (min-width: 760px) {
    margin: 0 5px 1.2rem 0;
    width: 256px;
    margin-bottom: 1.5rem;
    flex-direction: column;
  }
`;

const VTubers = styled(Wrapper)`
  width: 100%;
  justify-content: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
`;

const RightWrapper = styled(Wrapper)`
  width: 256px;
  @media (max-width: 760px) {
    width: calc(100% - 150px);
  }
`;

const Duration = styled(Wrapper)`
  background: ${(props) => props.theme.colors.duration};
  color: ${(props) => props.theme.colors.white};
  white-space: nowrap;
  position: absolute;
  right: 3px;
  bottom: 3px;
  border-radius: 3px;
  line-height: 1.2rem;
  padding: 0 0.2rem;
  font-size: 0.9rem;
`;

const ThumbnailWrapper = styled(Wrapper)``;

const sec_to_hms = (sec) => {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec - h * 3600) / 60);
  const s = String(sec % 60).padStart(2, 0);

  if (h === 0) {
    return `${m}:${s}`;
  }

  return `${h}:${String(m).padStart(2, 0)}:${s}`;
};

const created_at2str = (created_at) => {
  if (created_at.isAfter(dayjs().subtract(1, "days"))) {
    if (dayjs().diff(created_at, "hours") === 0) {
      return `${dayjs().diff(created_at, "minutes")}分前`;
    }
    return `${dayjs().diff(created_at, "hours")}時間前`;
  }
  if (created_at.isAfter(dayjs().subtract(1, "weeks"))) {
    return `${dayjs().diff(created_at, "days")}日前`;
  }
  if (created_at.isAfter(dayjs().subtract(1, "months"))) {
    return `${dayjs().diff(created_at, "weeks")}週間前`;
  }
  if (created_at.isAfter(dayjs().subtract(1, "years"))) {
    return `${dayjs().diff(created_at, "months")}ヶ月前`;
  }

  return `${dayjs().diff(created_at, "years")}年前`;
};

const ClipStreamItem = (props) => {
  const fragment = props.item.clip_fragments && props.item.clip_fragments[0];
  const vid = fragment.youtube_video;
  let thumbnail =
    vid &&
    vid.thumbnails &&
    vid.thumbnails.find((th) => th.resolution === "medium");
  const created_at_str =
    props.item && created_at2str(dayjs.utc(props.item.created_at));

  return (
    <StyledWrapper>
      <ThumbnailWrapper>
        <StyledA to={`/forum/clips/${props.item.id}`}>
          <StyledImg
            src={thumbnail && thumbnail.url}
            alt={props.item.title}
            loading="lazy"
            mobile
          />
          {props.item && <Duration>{sec_to_hms(props.item.duration)}</Duration>}
        </StyledA>
      </ThumbnailWrapper>

      <RightWrapper>
        <StyledA to={`/forum/clips/${props.item.id}`}>
          <Description>
            <Title mobile>{props.item.title}</Title>
            <DescriptionMiddle>
              <DescriptionContents>
                {props.item.loop_count}ループ
                <Separator />
                {props.item.clip_likes_count}いいね
                <Separator />
                {created_at_str}
              </DescriptionContents>
            </DescriptionMiddle>
            <VTubers>
              {props.item.vtubers.map((v) => (
                <SelectedVTuberListItem item={v} key={v.id.toString()} small />
              ))}
            </VTubers>
          </Description>
        </StyledA>
      </RightWrapper>
    </StyledWrapper>
  );
};

export default React.memo(ClipStreamItem);
